import { render, staticRenderFns } from "./SlcPaginationProvider.vue?vue&type=template&id=0f6f2659&"
import script from "./SlcPaginationProvider.vue?vue&type=script&lang=ts&"
export * from "./SlcPaginationProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports